import * as Cookies from 'js-cookie'
import * as amplitudeClient from '@amplitude/unified'

// https://github.com/js-cookie/js-cookie/wiki/Frequently-Asked-Questions#expire-cookies-in-less-than-a-day
const inFiveMinutes = new Date(Date.now() + 5 * 60 * 1000)
const logoutCookieName = 'USER_LOGOUT'

export const LOGOUT_URL = '/apps/logout?redirect=/'

// create cookie so app handling logout can show a transient message
export const performLogout = redirectPath => {
  // amplitude on logout. Otherwise it continues to associate logged out
  // user with the same user id. Should we keep that feature or remove
  // user id to make it an anonymous user again ?
  amplitudeClient.setUserId(undefined)
  amplitudeClient.identify(
    new amplitudeClient.Identify().set('loggedIn', false)
  )

  Cookies.set(logoutCookieName, 'y', { expires: inFiveMinutes })
  window.location.assign(redirectPath || LOGOUT_URL)
}

export const onLogoutHandlerFactory = path => e => {
  e.preventDefault()
  performLogout(path)
}

export const onLogoutHandler = onLogoutHandlerFactory(LOGOUT_URL)
